import React, { useState } from 'react';
import { Button, Menu, MenuItem, ListItemIcon, makeStyles, createStyles } from '@material-ui/core';
import { ArrowDropDown } from '@material-ui/icons';
import { Action, ActionCustom, ActionFunction } from '../local-types';

interface ActionsDropdownProps {
    dropdownText?: string;
    menuItems: Action[];
}

const ActionsDropdown: React.FC<ActionsDropdownProps> = ({ dropdownText = 'AUTRES ACTIONS', menuItems }) => {
    const classes = useActionsDropdownStyles();

    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

    const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    return (
        <div>
            <div className={classes.actions}>
                <Button variant="outlined" color="default" onClick={handleClick} className={classes.actionText}>
                    {dropdownText}
                </Button>
                <Button variant="outlined" color="default" onClick={handleClick} className={classes.actionIcon}>
                    <ArrowDropDown />
                </Button>
            </div>
            <Menu
                anchorEl={anchorEl}
                keepMounted
                open={Boolean(anchorEl)}
                onClose={handleClose}
                PaperProps={{
                    style: {
                        marginTop: 42, // Move items under the button
                    },
                }}
            >
                {menuItems.map((item, index) => {
                    if ((item as ActionCustom).customView) {
                        const action = item as ActionCustom;
                        return (
                            <MenuItem key={index}>
                                <div style={{ width: '-webkit-fill-available' }}>{action.customView}</div>
                            </MenuItem>
                        );
                    } else {
                        const action = item as ActionFunction;
                        return (
                            <MenuItem
                                key={index}
                                onClick={() => {
                                    handleClose();
                                    if (action.func) {
                                        action.func();
                                    }
                                }}
                                style={{ ...action.style }}
                            >
                                {action.icon && <ListItemIcon>{action.icon}</ListItemIcon>}
                                {item.label}
                            </MenuItem>
                        );
                    }
                })}
            </Menu>
        </div>
    );
};

const useActionsDropdownStyles = makeStyles(() =>
    createStyles({
        actions: {
            display: 'flex',
            flexDirection: 'row',

            '&:hover': {
                textDecoration: 'none',
                backgroundColor: 'rgba(0, 0, 0, 0.04)',
            },
        },
        actionText: {
            textTransform: 'none',
            borderRight: 'none',
            borderTopRightRadius: '0px',
            borderBottomRightRadius: '0px',

            '&:hover': {
                backgroundColor: 'unset',
            },
        },
        actionIcon: {
            padding: '5px',
            minWidth: '40px',
            borderTopLeftRadius: '0px',
            borderBottomLeftRadius: '0px',

            '&:hover': {
                backgroundColor: 'unset',
            },
        },
    }),
);

export default ActionsDropdown;
